import _defineProperty from '@babel/runtime/helpers/defineProperty';
import _slicedToArray from '@babel/runtime/helpers/slicedToArray';
import * as React from 'react';
import { useFormControl } from '../useFormControl/useFormControl.js';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var useFormField = function useFormField(_ref) {
  var rootProps = _ref.rootProps,
    inputProps = _ref.inputProps,
    clearButtonProps = _ref.clearButtonProps,
    validation = _ref.validation,
    textareaProps = _ref.textareaProps;
  var _React$useState = React.useState((rootProps === null || rootProps === void 0 ? void 0 : rootProps.state) || 'default'),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    state = _React$useState2[0],
    setState = _React$useState2[1];
  var _React$useState3 = React.useState({
      isValid: true,
      message: ''
    }),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    validationResult = _React$useState4[0],
    setValidationResult = _React$useState4[1];
  var formControl = useFormControl({
    rootProps: rootProps,
    inputProps: inputProps,
    textareaProps: textareaProps,
    clearButtonProps: clearButtonProps,
    validation: validation,
    setState: setState,
    setValidationResult: setValidationResult
  });
  return {
    rootProps: _objectSpread(_objectSpread({}, rootProps), {}, {
      state: state
    }),
    inputProps: formControl.inputProps,
    textareaProps: formControl.textareaProps,
    clearButtonProps: formControl.clearButtonProps,
    controlContainerProps: formControl.controlContainerProps,
    validationMessageProps: {
      validationResult: validationResult,
      controlContainerRef: formControl.controlContainerProps.ref
    },
    utilityProps: formControl.utilityProps
  };
};

export { useFormField };
//# sourceMappingURL=useFormField.js.map
